function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 16");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Br\xEDet",
  transform: "translate(-66.000000, -44.000000)"
}, React.createElement("g", {
  id: "Group-16",
  transform: "translate(66.000000, 44.000000)"
}, React.createElement("g", {
  id: "Group-12"
}, React.createElement("g", {
  id: "Group-5"
}, React.createElement("g", {
  id: "Group",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("path", {
  d: "M14.2580645,26.2580645 C14.2580645,26.2580645 14,26.2580645 14.2580645,26.2580645 L14,33.7419355 C14,33.7419355 14,34 14.2580645,34 L21.7419355,34 C21.7419355,34 22,34 22,33.7419355 L22,26.2580645 C22,26.2580645 22,26 21.7419355,26 L14.2580645,26 L14.2580645,26.2580645 Z",
  id: "gult-hus",
  fill: "#FFB053"
}), React.createElement("path", {
  d: "M34.5068493,9.86789312 L17.4931507,0 C17.2465753,0 17.2465753,0 17,0 L17,16.2820236 C17.2465753,16.2820236 17.2465753,16.2820236 17.4931507,16.2820236 L34.260274,25.9032194 C34.5068493,26.1499168 35,25.9032194 35,25.4098248 L35,10.1145904 C34.7534247,10.1145904 34.7534247,10.1145904 34.5068493,9.86789312 Z",
  id: "gult-2",
  fill: "#FFB053"
}), React.createElement("polygon", {
  id: "gult-1",
  fill: "#DE8720",
  points: "0 10.0566038 0 26 17 16.1886792 17 0"
}))), React.createElement("text", {
  id: "briet-text",
  fontFamily: "Averta",
  fontSize: 20,
  fontWeight: 700,
  fill: "#393939"
}, React.createElement("tspan", {
  x: 61,
  y: 24
}, "Leiguf\xE9lagi\xF0 Br\xEDet")))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "230px",
    height: "34px",
    viewBox: "0 0 230 34",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/logo-briet.e2ba2b64.svg";
export { SvgComponent as ReactComponent };